import { useQuery } from "@apollo/client";
import Errors from "components/base/Errors";
import SearchBar from "components/base/SearchBar";
import Spinner from "components/base/Spinner";
import PageV2 from "components/shared/PageV2";
import useSearch from "hooks/useSearch";
import { Link } from "react-router-dom";
import { searchByProp } from "utils/search";
import { FETCH_SUPPLIERS } from "./onboarding/graphql";
import SupplierListCertificatesView from "./SupplierListCertificatesView";

const SUPPLIER_CLASS_EMOJI = {
  1: "①",
  2: "②",
  3: "③",
};

function formatSupplierClass(supplierClass) {
  if (
    supplierClass === null ||
    supplierClass === undefined ||
    supplierClass === ""
  ) {
    return "❓";
  }

  return SUPPLIER_CLASS_EMOJI[supplierClass] || `[${supplierClass}]`;
}

const SupplierListPage = () => {
  const { loading, error, data } = useQuery(FETCH_SUPPLIERS, {
    variables: {
      withRanking: true,
      hasOdooPartners: true,
      statesIn: ["COMPLETED_ONBOARDING"],
    },
    fetchPolicy: "network-only",
  });
  const [q, setQ] = useSearch();

  if (loading) return <Spinner />;
  if (error) return <Errors error={error} />;

  const suppliers = data.suppliers.filter((i) =>
    searchByProp(i, ["nickName", "trackingLabel"], q),
  );

  console.log("suppliers", suppliers);

  return (
    <PageV2
      className="h-screen"
      title="Suppliers"
      toolbar={
        <div className="flex space-x-6">
          <Link to="onboarding">Onboarding</Link>
          <a
            href={`${
              process.env.REACT_APP_SERVER_ADMIN_URL + "csr/csrfactory/"
            }`}
            target="_blank"
            rel="noopener noreferrer"
          >
            Admin
          </a>
        </div>
      }
    >
      <div className="flex items-center space-x-6">
        <div className="flex-1">
          <SearchBar
            placeholder="Search by name or tracking label"
            autoFocus
            initialQuery={q}
            onChange={setQ}
          />
        </div>
      </div>
      <div className="card p-0 flex-1 overflow-auto whitespace-nowrap mt-0">
        <table>
          <thead>
            <tr className="sticky top-0 z-10 backdrop-blur bg-gray-50 bg-opacity-80">
              <th className="px-4 py-3">Supplier</th>
              <th className="px-4">Tracking Label</th>
              <th className="px-4">Contact</th>
              <th className="px-4 w-full">Address</th>
              <th className="px-4 w-full">Main Products</th>
              <th className="px-4">Supplier Certificates</th>
            </tr>
          </thead>
          <tbody>
            {suppliers.map((i) => (
              <tr
                key={i.id}
                className="border-y border-gray-100 dark:border-gray-700"
              >
                <td className="px-4">
                  <div className="flex items-center space-x-1">
                    <div>
                      <div className="opacity-70">W#{i.id}</div>
                      <Link
                        to={`${i.id}`}
                        className="inline-flex items-center gap-1"
                      >
                        <span
                          className={
                            SUPPLIER_CLASS_EMOJI[i.supplierClass]
                              ? "text-base leading-none"
                              : undefined
                          }
                        >
                          {formatSupplierClass(i.supplierClass)}
                        </span>
                        {i.nickName}
                      </Link>
                    </div>
                  </div>
                  {i.odooPartners.length === 0 && (
                    <div className="mt-1 opacity-70">⚠️ No Company</div>
                  )}
                </td>
                <td className="px-4">{i.trackingLabel || "-"}</td>
                <td className="px-4">
                  {i.user && (
                    <div className="font-semibold">{i.user.email}</div>
                  )}
                  <div className={i.user ? "mt-1" : "mt-0"}>
                    {i.contactPerson}
                  </div>
                  <div>{i.phone}</div>
                  <div>{i.email}</div>
                </td>
                <td className="px-4 whitespace-pre-wrap">
                  <div>{i.contactAddress}</div>
                </td>
                <td className="px-4 whitespace-nowrap break-all">
                  {i.mainProducts}
                </td>
                <td className="px-4 whitespace-normal">
                  <SupplierListCertificatesView supplier={i} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </PageV2>
  );
};

export default SupplierListPage;
